import { takeEvery, takeLatest } from "redux-saga/effects";
import { TestCall } from "../Slicers/TestSlicers/TestApi";
import { ListUserPermissionCall } from "../Slicers/UserPermission/UserPermissionAPI";
import { ListUserPermissionRowsCall } from "../Slicers/UserPermission/UserPermissionAPI";
import { LoginCall,ForgotCall } from "../Slicers/LoginSlicer/LoginApi";

import {
  AddMasterCall,
  DeleteMasterCall,
  MasterCall,
  UpdateMasterCall,
  UnlockMasterCall,
} from '../Slicers/Master/MasterApi';

import {
  AddDesignationCall,
  DeleteDesignationCall,
  DesignationCall,
  UpdateDesignationCall,
} from '../Slicers/Designation/DesignationApi';

import {
  AddSpaceTypesCall,
  DeleteSpaceTypesCall,
  SpaceTypesCall,
  UpdateSpaceTypesCall,
} from '../Slicers/SpaceTypes/SpaceTypesApi';

import {
  ForgetPasswordCall,
  ForgetPasswordMailCall,
} from '../Slicers/ForgetPassword/ForgetPasswordApi';

import {
  AddOwnerCall,
  OwnerCall,
  UpdateOwnerCall,
  DeleteOwnerCall,
} from '../Slicers/Owner/OwnerApi';

import {
  AddpricingCall,
  pricingCall,
  UpdatepricingCall,
  DeletepricingCall,
} from '../Slicers/Pricing/PricingApi';

import {
  AddVehicleCall,
  VehicleCall,
  UpdateVehicleCall,
  DeleteVehicleCall,
  VehicleSearchCall,
} from "../Slicers/Vehicle/VehicleApi";

import {
  AddLocationCall,
  LocationCall,
  UpdateLocationCall,
  DeleteLocationCall,
  GetLocationCall,
  GetAdsCall,
} from "../Slicers/Location/LocationApi";
import { DashboardCardCall } from "../Slicers/Dashboard/DashboardApi";

import {
  AddTariffCall,
  DeleteTariffCall,
  TariffCall,
  UpdateTariffCall,
} from "../Slicers/Tariff/TariffApi";
import { SalesCall, SubscribeCall } from "../Slicers/Sales/SalesApi";
import { ParkingTypeCall } from "../Slicers/ParkingType/ParkTypeApi";
import {
  AddSlotCall,
  DeleteSlotCall,
  SlotCall,
  UpdateSlotCall,
  UpdateSlotOrderCall,
} from "../Slicers/Slot/SlotApi";
import {
  AddFixtureCall,
  DeleteFixtureCall,
  FixtureCall,
  UpdateFixtureCall,
  UpdateFixtureOrderCall,
} from "../Slicers/Fixtures/FixtureApi";

import {
  AddSpaceCall,
  DeleteSpaceCall,
  SpaceCall,
  UpdateSpaceCall,
  UpdateSpaceOrderCall,
} from "../Slicers/Space/SpaceApi";
import {
  AddDayOfWeekCall,
  DayOfWeekCall,
  DeleteDayOfWeekCall,
} from "../Slicers/DayOfWeek/DayOfWeekApi";
import {
  SpecialDayCall,
  AddSpecialDayCall,
  UpdateSpecialDayCall,
  DeleteSpecialDayCall,
} from "../Slicers/SpecialDay/SpecialDayApi";
import {
  AddMembershipVehicleCall,
  DeleteMembershipVehicleCall,
  MembershipVehicleCall,
  UpdateMembershipVehicleCall,
} from "../Slicers/MembershipVehicle/MembershipVehicleApi";
import {
  PackageManagementCardCall,
  AddPackageCall,
  UpdatePackageCall,
  DeletePackageCall,
} from "../Slicers/PackageManagement/PackageManagementApi";
import {
  AdminCreateUserCall,
  DeleteUserCall,
  UpdateUserCall,
  UsersListCall,
} from "../Slicers/Users/UsersApi";
import {
  AddDisplayDeviceCall,
  DeleteDisplayDeviceCall,
  DisplayDeviceCall,
  UpdateDisplayDeviceCall,
} from "../Slicers/DisplayDevice/DisplayDeviceApi";
export default function* rootSage(): any {
  yield takeLatest("Test/testCall", TestCall);
  // yield takeLatest("pattern",worker)
  // User Permission
  yield takeLatest(
    "UserPermissionRoles/userPermissionList",
    ListUserPermissionCall
  );
  yield takeLatest(
    "UserPermissionRows/userPermissionRowsList",
    ListUserPermissionRowsCall
  );
  yield takeLatest("LoginSlicer/loginStart", LoginCall);
  yield takeLatest("LoginSlicer/forgotPassStart", ForgotCall);
  // Dashboard
  yield takeLatest("DashboardCard/dashboardCard", DashboardCardCall);

  // Master
  yield takeLatest("Master/getMaster", MasterCall);
  yield takeLatest("AddMaster/addMaster", AddMasterCall);
  yield takeLatest("UpdateMaster/updateMaster", UpdateMasterCall);
  yield takeLatest("DeleteMaster/deleteMaster", DeleteMasterCall);
  yield takeLatest("UnlockMaster/unlockMaster", UnlockMasterCall);

  // SpecialDay
  yield takeLatest("SpecialDay/getSpecialDay", SpecialDayCall);
  yield takeLatest("AddSpecialDay/addSpecialDay", AddSpecialDayCall);
  yield takeLatest("UpdateSpecialDay/updateSpecialDay", UpdateSpecialDayCall);
  yield takeLatest("DeleteSpecialDay/deleteSpecialDay", DeleteSpecialDayCall);

  // Designation
  yield takeLatest("Designation/getDesignation", DesignationCall);
  yield takeLatest("AddDesignation/addDesignation", AddDesignationCall);
  yield takeLatest(
    "UpdateDesignation/updateDesignation",
    UpdateDesignationCall
  );
  yield takeLatest(
    "DeleteDesignation/deleteDesignation",
    DeleteDesignationCall
  );

  // SpaceTypes
  yield takeLatest("SpaceTypes/getSpaceTypes", SpaceTypesCall);
  yield takeLatest("AddSpaceTypes/addSpaceTypes", AddSpaceTypesCall);
  yield takeLatest("UpdateSpaceTypes/updateSpaceTypes", UpdateSpaceTypesCall);
  yield takeLatest("DeleteSpaceTypes/deleteSpaceTypes", DeleteSpaceTypesCall);

  // DayOfWeek
  yield takeLatest("DayOfWeek/getDayOfWeek", DayOfWeekCall);
  yield takeLatest("AddDayOfWeek/addDayOfWeek", AddDayOfWeekCall);
  //  yield takeLatest('UpdateDayOfWeek/updateDayOfWeek', UpdateDayOfWeekCall);
  yield takeLatest("DeleteDayOfWeek/deleteDayOfWeek", DeleteDayOfWeekCall);

  // ForgetPassword
  yield takeLatest("ForgetPassword/forgetPassword", ForgetPasswordCall);
  yield takeEvery(
    "ForgetPasswordMail/forgetPasswordMail",
    ForgetPasswordMailCall
  );
  //Owner
  yield takeEvery("Owner/getOwner", OwnerCall);
  yield takeEvery("AddOwner/addOwner", AddOwnerCall);
  yield takeEvery("UpdateOwner/updateOwner", UpdateOwnerCall);
  yield takeEvery("DeleteOwner/deleteOwner", DeleteOwnerCall);

  //package
  //Owner
  yield takeLatest(
    "PackageManagementCard/packageManagementCard",
    PackageManagementCardCall
  );
  yield takeEvery("AddPackage/addPackage", AddPackageCall);
  yield takeEvery("UpdatePackage/updatePackage", UpdatePackageCall);
  yield takeEvery("DeletePackage/deletePackage", DeletePackageCall);

  //pricing
  yield takeEvery("Pricing/getPricing", pricingCall);
  yield takeEvery("AddPricing/addPricing", AddpricingCall);
  yield takeEvery("UpdatePricing/updatePricing", UpdatepricingCall);
  yield takeEvery("DeletePricing/deletePricing", DeletepricingCall);

  //Vehicle
  yield takeEvery("Vehicle/getVehicle", VehicleCall);
  yield takeEvery("Vehicle/getVehicleSearch", VehicleSearchCall);

  yield takeEvery("AddVehicle/addVehicle", AddVehicleCall);
  yield takeEvery("UpdateVehicle/updateVehicle", UpdateVehicleCall);
  yield takeEvery("DeleteVehicle/deleteVehicle", DeleteVehicleCall);

  //MembershipVehicle
  yield takeEvery(
    "MembershipVehicle/getMembershipVehicle",
    MembershipVehicleCall
  );
  yield takeEvery(
    "AddMembershipVehicle/addMembershipVehicle",
    AddMembershipVehicleCall
  );
  yield takeEvery(
    "UpdateMembershipVehicle/updateMembershipVehicle",
    UpdateMembershipVehicleCall
  );
  yield takeEvery(
    "DeleteMembershipVehicle/deleteMembershipVehicle",
    DeleteMembershipVehicleCall
  );

  //Location
  yield takeEvery("Location/getLocation", LocationCall);
  yield takeEvery("AddLocation/addLocation", AddLocationCall);
  yield takeEvery("UpdateLocation/updateLocation", UpdateLocationCall);
  yield takeEvery("DeleteLocation/deleteLocation", DeleteLocationCall);
  yield takeEvery("GetOneLocation/getOneLocation", GetLocationCall);
  yield takeEvery("GetAds/getAds", GetAdsCall);

  // Tariff
  yield takeLatest("Tariff/getTariff", TariffCall);
  yield takeLatest("AddTariff/addTariff", AddTariffCall);
  yield takeLatest("UpdateTariff/updateTariff", UpdateTariffCall);
  yield takeLatest("DeleteTariff/deleteTariff", DeleteTariffCall);
  //slot
  yield takeLatest("Slot/getSlot", SlotCall);
  yield takeLatest("AddSlot/addSlot", AddSlotCall);
  yield takeLatest("UpdateSlot/updateSlot", UpdateSlotCall);
  yield takeLatest("UpdateSlotOrder/updateSlotOrder", UpdateSlotOrderCall);
  yield takeLatest("DeleteSlot/deleteSlot", DeleteSlotCall);

  //Fixture
  yield takeLatest("Fixture/getFixture", FixtureCall);
  yield takeLatest("AddFixture/addFixture", AddFixtureCall);
  yield takeLatest("UpdateFixture/updateFixture", UpdateFixtureCall);
  yield takeLatest("DeleteFixture/deleteFixture", DeleteFixtureCall);
  yield takeLatest(
    "UpdateFixtureOrder/updateFixtureOrder",
    UpdateFixtureOrderCall
  );

  //Space
  yield takeLatest("Space/getSpace", SpaceCall);
  yield takeLatest("AddSpace/addSpace", AddSpaceCall);
  yield takeLatest("UpdateSpace/updateSpace", UpdateSpaceCall);
  yield takeLatest("UpdateSpaceOrder/updateSpaceOrder", UpdateSpaceOrderCall);
  yield takeLatest("DeleteSpace/deleteSpace", DeleteSpaceCall);

  //parkingType
  yield takeLatest("ParkingType/getParkingType", ParkingTypeCall);

  //sales
  yield takeLatest("Sales/getSales", SalesCall);
  yield takeLatest("Subscription/getSubscription", SubscribeCall);

  // Users
  yield takeLatest("Users/getUsers", UsersListCall);
  yield takeLatest("UsersCreate/adminCreateUser", AdminCreateUserCall);
  yield takeLatest("UsersUpdate/updateUser", UpdateUserCall);
  yield takeLatest("UsersDelete/deleteUser", DeleteUserCall);

  // DisplayDevice
  yield takeLatest("DisplayDevice/getDisplayDevice", DisplayDeviceCall);
  yield takeLatest("AddDisplayDevice/addDisplayDevice", AddDisplayDeviceCall);
  yield takeLatest("UpdateDisplayDevice/updateDisplayDevice", UpdateDisplayDeviceCall);
  yield takeLatest("DeleteDisplayDevice/deleteDisplayDevice", DeleteDisplayDeviceCall);
}
